import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { INMUEBLE, DATOS_INQUILINO, INFO_ARRENDAMIENTOS_NO_IQ, DURACION_CONTRATO, PLANES_SEGUROS, DATOS_PROPIETARIO, INFO_INMUEBLE, INICIO, HOME, INFO_ARRENDAMIENTOS } from 'src/app/routes.constants';

@Component({
  selector: 'app-banner-app',
  templateUrl: './banner-app.component.html',
  styleUrls: ['./banner-app.component.scss']
})
export class BannerAppComponent implements OnInit {
  private startDate: Date = new Date(environment.bannerStartDate);
  private endDate: Date = new Date(environment.bannerEndDate);
  showBanner: boolean = environment.bannerEnabled && this.isWithinActivePeriod();;


  @Input() retroSelected!: boolean;
  @Input() PaginaAnterior: string = '';
  @Input() Parametros: string = '';
  @Input() IdentLead: string = '';
  @Input() codAsesor: string = '';
  @Input() bitacoraId: string = '';

  constructor(private router: Router) { }

  ngOnInit(): void {


  }

  private isWithinActivePeriod(): boolean {
    const now = new Date();
    return now >= this.startDate && now <= this.endDate;
  }

  regresarPagina() {
    switch (this.PaginaAnterior) {
      case 'Home':
        this.router.navigate([HOME], { queryParams: { idLead: this.IdentLead, infoCliente: btoa(this.Parametros) } });
        break;
      case 'Inicio':
        this.router.navigate([INICIO], { queryParams: { idLead: this.IdentLead, infoCliente: btoa(this.Parametros) } });
        break;
      case 'InfoArriendo':
        this.router.navigate([INFO_ARRENDAMIENTOS], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;
      case 'InfoArrendamientosNoIQ':
        this.router.navigate([INFO_ARRENDAMIENTOS_NO_IQ], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;
      case 'DuracionContrato':
        this.router.navigate([DURACION_CONTRATO], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;
      case 'PlanesSeguros':
        this.router.navigate([PLANES_SEGUROS], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;
      case 'DatosPropietario':
        this.router.navigate([DATOS_PROPIETARIO], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;
      case 'InfoImmueble':
        this.router.navigate([INFO_INMUEBLE], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;
      case 'DatosInquilino':
        this.router.navigate([DATOS_INQUILINO], { queryParams: { codigoAsesor: this.codAsesor, idLead: this.IdentLead, infoCliente: btoa(this.Parametros), bitacoraId: this.bitacoraId } });
        break;

    }
  }
}
